import _ from 'lodash';
import { COMMENT_COLOR } from './constants';

export function assignColorToComments(comments = []) {
  const BG_COLORS = _.keys(COMMENT_COLOR);
  const commentsBySubmitterId = _.groupBy(
    _.sortBy(comments, 'createdDate'),
    'commenterId',
  );
  const colorBySubmitterId = _.keys(commentsBySubmitterId).map(
    (commenterId, i) => {
      return {
        commenterId,
        color: BG_COLORS[i % BG_COLORS.length],
      };
    },
  );
  return comments.map(comment => {
    const { commenterId } = comment;
    return {
      ...comment,
      color: _.get(
        _.find(colorBySubmitterId, { commenterId }),
        'color',
        COMMENT_COLOR.A1,
      ),
    };
  });
}
